import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { saasApi, type SaaSTenant, type TenantBranding } from '../../api/saas';

export function WhiteLabelManagerPage() {
  const [tenants, setTenants] = useState<SaaSTenant[]>([]);
  const [branding, setBranding] = useState<TenantBranding | null>(null);

  useEffect(() => {
    void saasApi.tenants().then((t) => {
      setTenants(t);
      if (t[0]) void saasApi.getBranding(t[0].id).then(setBranding);
    });
  }, []);

  return (
    <div className="mx-auto max-w-4xl p-6">
      <Link to="/saas" className="text-sm text-slate-600 hover:underline dark:text-slate-400">← Global SaaS Dashboard</Link>
      <h1 className="mt-2 text-2xl font-semibold">White Label Manager</h1>
      {branding && (
        <div className="mt-6 rounded-xl border p-6 dark:border-slate-700" style={{ backgroundColor: branding.primary_color ?? '#1e293b', color: '#fff' }}>
          <p className="text-lg font-semibold">{branding.display_name ?? tenants[0]?.name}</p>
          <p className="mt-2 text-sm opacity-80">Theme: {branding.theme} · Accent: {branding.accent_color}</p>
          {branding.logo_url && <p className="mt-2 text-xs opacity-60">Logo: {branding.logo_url}</p>}
        </div>
      )}
      <p className="mt-4 text-sm text-slate-500">Configure custom domains, login pages, email templates and CSS overrides in Branding Center.</p>
    </div>
  );
}
